import { isVerifyMobileErrorResponse } from '../validators/verifyMobileValidators';
import { createGenericTransformVerifyErrorResponse } from '../validation.helpers';

export const transformVerifyMobilePhoneNumberErrorResponse =
  createGenericTransformVerifyErrorResponse(isVerifyMobileErrorResponse);
